<template>
  <div v-if="contentLoaded" class="container_12">
    <div class="row-fluid" v-if="stage === 0">
      <div v-html="content" />
    </div>
    <div class="row-fluid">
      <Step1
        v-if="stage === 1"
        :key="stage"
        :accountInfo="{ accountInfo }"
        :currency="{ currency }"
        :canxVal="{ canxVal }"
        @nextStage="(i) => (stage = i)"
      />
      <Step2
        v-if="stage === 2"
        :key="stage"
        :accountInfo="{ accountInfo }"
        :currency="{ currency }"
        :canxVal="{ canxVal }"
        @nextStage="(i) => (stage = i)"
      />
      <Step3
        v-if="stage === 3"
        :key="stage"
        :accountInfo="{ accountInfo }"
        :currency="{ currency }"
        :canxVal="{ canxVal }"
        @sendSMS="sendSMS"
      />
      <Step4
        v-if="stage === 4"
        :key="stage"
        :accountInfo="{ accountInfo }"
        :currency="{ currency }"
        :canxVal="{ canxVal }"
        @sendSMS="sendSMS"
        @checkThenSend="checkThenSend"
      />
      <Step5
        v-if="stage === 5"
        :key="stage"
        :canxError="{ canxError }"
        :canxSuccess="{ canxSuccess }"
      />
    </div>
    <b-form-checkbox
      id="canx-checkbox"
      v-model="confirmCheckbox"
      name="canx-checkbox"
      value="true"
      unchecked-value="false"
      class="d-flex justify-content-center mt-5 mb-3"
    >
      I confirm that I have read and understood the cancellation conditions for
      my trip.
    </b-form-checkbox>
    <div class="d-flex justify-content-center my-4">
      <b-button
        class="my-3"
        variant="primary"
        :disabled="confirmCheckbox === 'false'"
        @click="$emit('nextModal', 3)"
      >
        Proceed
      </b-button>
    </div>
    <ServiceErrorMessage :error-loading-data="errorLoadingData" />
    <LoginToken ref="LoginTokenRef" />
  </div>
</template>

<script>
import dayjs from '@/lib/dayjs';
import LoginToken from "@/modules/auth/login-token";
import ServiceErrorMessage from "@/partials/service-error-message";
import { getCancellationConditions, sendSMS, checkSMS } from "./services";
import Step1 from "./step1.vue";
import Step2 from "./step2.vue";
import Step3 from "./step3.vue";
import Step4 from "./step4.vue";
import Step5 from "./step5.vue";
import { mapGetters } from "vuex";
export default {
  components: {
    LoginToken,
    ServiceErrorMessage,
    Step1,
    Step2,
    Step3,
    Step4,
    Step5,
  },
  data() {
    return {
      contentLoaded: false,
      content: "",
      smsError: false,
      canxError: false,
      canxSuccess: false,
      showCancellationButton: false,
      errorLoadingData: false,
      stage: 0,
      confirmCheckbox: "false",
      // errorFetchingData:
      //   "<p>We're sorry but something went wrong. Please try again or, if that does not work, contact us to discuss alternative payment options.</p>",
    };
  },
  async mounted() {
    // // If we have content then we can just show that
    // if (this.content !== "") {
    //   return;
    // }

    // Show loading spinner on top of the modal
    this.$store.dispatch("spinner/updateLoadingAction", true, { root: true });
    // Get content from service
    let result = await getCancellationConditions(
      this.bookingNumber,
      this.bookingName
    );
    if (result.error === true) {
      // this.content = this.errorFetchingData;
      this.errorLoadingData = true;
    }
    if (result.data) {
      this.content = result.data;
    }
    // Can we display the cancellation button?
    if (this.accountInfo.cancellationavailable !== "NO") {
      this.showCancellationButton = true;
    }
    // stop spinner
    this.$store.dispatch("spinner/updateLoadingAction", false, {
      root: true,
    });
  },
  computed: {
    ...mapGetters({
      userData: "auth/getUserData",
      bookingContacts: "booking/getBookingContacts",
      bookingNumber: "booking/getBookingNumber",
      bookingName: "booking/getBookingSurname",
      accountInfo: "booking/getAccount",
      bookingData: "booking/getBooking",
      isAuthorisedWithToken: "auth/isAuthorisedWithToken",
      bookingInfo: "booking/getBookingInfo",
    }),
    contentWatcher() {
      return this.content;
    },
    // Used for the footer
    returnDate() {
      return dayjs().format("DD-MMM-YYYY HH:mm");
    },
    canxDate() {
      return dayjs().format("ddd DD MMM YYYY");
    },
    refundDate() {
      return dayjs().add(12, "weeks").format("ddd DD MMM YYYY");
    },
    currency() {
      return this.userData.bookno.charAt(0).toUpperCase() === "R" ? "€" : "£";
    },
    canxVal() {
      let _tmp = Math.round(this.accountInfo.cancellationvalue * 100) / 100;
      return _tmp.toFixed(2);
    },
  },
  methods: {
    async checkThenSend(_code) {
      this.canxError = false;
      this.canxSuccess = false;
      const _data = {
        code: _code,
        bookno: this.bookingNumber,
        refund: {
          booking_number: this.bookingNumber,
          client_name: this.bookingData.user_information.names[0],
          leadname: this.bookingData.user_information.names[0],
          booking_date: this.bookingData.booking_information.vtdate_created,
          cancellation_date: this.canxDate,
          address1: this.bookingData.user_information.bookingAddress.address_01,
          address2: this.bookingData.user_information.bookingAddress.address_02,
          address3: this.bookingData.user_information.bookingAddress.address_03,
          postcode: this.bookingData.user_information.bookingAddress.postcode,
          paxnames: this.bookingData.user_information.names.concat(),
          email: this.bookingData.user_information.email,
          currency: this.currency,
          total_paid: this.accountInfo.totalCost.replace(this.currency, ""),
          canx_cost: this.accountInfo.cancellationvalue,
          refund_date: this.refundDate,
          canx_text: this.accountInfo.cancellationtext,
          destination: this.bookingData.booking_information.country,
          bcc: ["cancel@trailfinders.com", "stephenc@trailfinders.com"],
        },
      };
      let _resp = await checkSMS(_data);

      if (_resp !== "ok") {
        this.canxError = true;
        this.stage = 5;
      } else {
        this.canxSuccess = true;
        this.stage = 5;
      }
    },
    async sendSMS() {
      const bookingInfo = {
        clientname: this.bookingName,
        custno: this.userData.custno,
        bookno: this.bookingNumber,
        email: this.bookingData.user_information.email,
        staffbkg: false,
        system: this.userData.system,
        tf_phone: this.bookingContacts[0].line0.telno,
      };
      let res = await sendSMS(bookingInfo);
      if (res === "ok") {
        this.stage = 4;
      } else {
        this.smsError = true;
      }
    },
  },
  watch: {
    // content(newValue) {
    //   if (newValue !== "") {
    //     this.contentLoaded = !this.contentLoaded;
    //   }
    // },
    contentWatcher(newValue) {
      if (newValue !== "") {
        this.contentLoaded = !this.contentLoaded;
      }
    },
  },
};
</script>
<style lang="scss">
@import "./styles.scss";
</style>
